@if (service.available()) {
  <button type="button" [attr.aria-expanded]="open()" (click)="open.set(!open())">{{ 'testData.title' | translate }}</button>
  @if (open()) {
    <section class="test-data-panel" [attr.aria-label]="'testData.title' | translate">
      @if (service.running() && !service.progress()?.done) {
        <p role="status" aria-live="polite">
          @if (service.progress()?.kind; as kind) {
            {{ ('testData.' + kind) | translate }} {{ service.progress()?.completed }}/{{ service.progress()?.total }}
          } @else { {{ 'testData.preparing' | translate }} }
        </p>
      } @else {
        <label>{{ 'testData.organization' | translate }}
          <select #target (change)="organization.set(target.value)">
            <option value="" [selected]="!organization()">{{ 'testData.select' | translate }}</option>
            @for (item of directory().items; track item.guid) { <option [value]="item.guid" [selected]="organization() === item.guid">{{ item.name }}</option> }
          </select>
        </label>
        @if (directory().error) { <p role="alert">{{ 'testData.failed' | translate }}</p> }
        <label>{{ 'testData.scenario' | translate }}
          <input #scenarioInput type="text" maxlength="300" [value]="scenario()" (input)="scenario.set(scenarioInput.value)">
        </label>
        @for (kind of kinds; track kind) {
          <div class="quantity-row">
            <label>{{ ('testData.' + kind) | translate }}
              <input #count type="number" min="0" max="30" step="1" [value]="counts()[kind]" (input)="setCount(kind, count.value)">
            </label>
            @if (randomKinds.includes(kind)) {
              <label class="random-status"><input #random type="checkbox" [checked]="statuses()[kind] ?? false" (change)="setRandom(kind, random.checked)">{{ 'testData.random' | translate }}</label>
            }
          </div>
        }
        <p>{{ 'testData.total' | translate }}: {{ total() }} / 100</p>
        <button type="button" [disabled]="!valid()" (click)="generate()">{{ 'testData.generate' | translate }}</button>
      }
      @if (service.progress(); as progress) {
        @if (progress.testDataBatchId) { <p class="batch-id">{{ 'testData.batch' | translate }}: {{ progress.testDataBatchId }}</p> }
        @if (!service.running() || progress.done) {
          @if (progress.done) {
            <p role="status">{{ 'testData.completed' | translate }}</p>
            <ul>@for (item of created(); track item.label) { <li>{{ ('testData.' + item.label) | translate }}: {{ item.count }}</li> }</ul>
          }
          @if (progress.failed) { <p role="alert">{{ 'testData.failed' | translate }}</p> }
          @for (error of progress.errors ?? []; track $index) {
            <p role="alert">@if (error.kind) { {{ ('testData.' + error.kind) | translate }} {{ error.index }}: }{{ ('testData.errors.' + error.code) | translate }}</p>
          }
        }
      }
    </section>
  }
}
